//@ts-nocheck
import React, { useEffect, useState } from "react";
import styles from "./ContinuationData.module.scss";
import { v4 as uuid } from "uuid";
import ContinuationDataForm from "./ContinuationDataForm/ContinuationDataForm";
import getContinuationData from "../../../utils/getContinuationData";
import { Button } from "@factorearth/component-library";

function ContinuationData(props) {
	const { continuationId, continuationData, online, handleSubmit, handleChange, color, fieldTemplate } = props;

	const [currentContinuationId, setCurrentContinuationId] = useState(continuationId);
	const [currentContinuationData, setCurrentContinuationData] = useState(continuationData);
	const [expanded, setExpanded] = useState(false);
	const [loaded, setLoaded] = useState(false);

	useEffect(() => {
		async function getContinuation(id, online) {
			const data = await getContinuationData(id, online);
			setCurrentContinuationData(data);
			setLoaded(true);
		}

		if (continuationId) {
			if (!continuationData) {
				// retrieve continuation data.
				getContinuation(continuationId, online);
			} else {
				setLoaded(true);
			}
		} else {
			setLoaded(true);
		}
	}, [continuationId, continuationData, online]);

	function renderContinuationForm() {
		return (
			<ContinuationDataForm continuationData={currentContinuationData} fieldTemplate={fieldTemplate} color={color} handleSubmitCb={handleSubmitItem} />
		);
	}

	function handleNewContinuationData() {
		const newId = uuid();
		const newContinuationData = {
			id: newId,
			group: fieldTemplate.group,
			readGroups: fieldTemplate.readGroups,
			continuationActions: [],
			fieldTemplateId: "",
			formTemplateId: "",
			instanceToContinueOn: "",
			parentFormTemplateId: fieldTemplate.formTemplate,
		};
		setCurrentContinuationData(newContinuationData);
		setCurrentContinuationId(newId);
	}

	function handleSave() {
		handleSubmit();
		setExpanded(false);
	}

	function handleSubmitItem(data, index) {
		const newObj = {
			continuationData: data,
			continuationDataId: data.id,
		};

		handleChange(newObj);
		setCurrentContinuationData(data);
	}

	function toggleExpand() {
		setExpanded(!expanded);
	}

	return (
		<div>
			{loaded ? (
				<div>
					{expanded ? (
						<div>
							<div>
								{currentContinuationId ? (
									<div>{renderContinuationForm()}</div>
								) : (
									<div>
										New Continuation Data!
										<button data-test="continuation-create-new" onClick={handleNewContinuationData}>
											Create
										</button>
									</div>
								)}
								<div>
									<button data-test="continuation-final-save" onClick={handleSave}>
										Save
									</button>
									<button data-test="continuation-final-close" onClick={toggleExpand}>
										Close
									</button>
								</div>
							</div>
						</div>
					) : (
						<div className={styles.edit_continuation_button} data-test="edit-continuation-field-button">
							Edit Continuation Data
							<Button colorPalette={color} onClick={toggleExpand}>
								Edit Continuation Data
							</Button>
						</div>
					)}
				</div>
			) : (
				<div>Loading...</div>
			)}
		</div>
	);
}

export default ContinuationData;
